import React, { useState } from 'react'
import profile from '../../assets/profile.png'
import { PiSubtitles } from "react-icons/pi";
import { MdOutlineSubject } from "react-icons/md";
import { GrAttachment } from "react-icons/gr";
import { FaUsers } from "react-icons/fa6";
import { TbProgress } from "react-icons/tb";


const TodoInfo = ({setOpenInfo, post}) => {
    const [openTeam, setOpenTeam] = useState(null)

    const handleClick = (i) => {
        if(openTeam === i){
            setOpenTeam(null)
        }else{
            setOpenTeam(i)
        }
    }

  return (
    <div className='todo__info' onClick={()=>setOpenInfo(false)}>
        <div className="todo__info-content" onClick={(e)=>e.stopPropagation()}>
            <button 
            onClick={()=>setOpenInfo(false)}
            className="todo__info-btn">
                <i class='bx bx-x'></i>
            </button>
            {
                post?.attachment && <img src={`https://backend.aspomportal.com/upload/${post?.attachment}`} 
                alt="" className="todo__info-img" />
            }
            <h2 className="todo__info-title">
                <PiSubtitles size={25}/>
                {post?.title}
            </h2>
            <div className="todo__info-item">
                <h4 className="todo__info-title">
                    <MdOutlineSubject size={20}/>
                    Description
                </h4>
                <div className="todo__info-desc"
                dangerouslySetInnerHTML={{__html: post?.description}}>
                </div>
            </div>
            <div className="todo__info-item">
                <h4 className="todo__info-title">
                    <TbProgress size={20}/>
                    Progress
                </h4>
                    <div className="todo__card-div_span" style={{width:'100%'}}>
                        <span>Progress</span>
                        <span>{post?.progress}%</span>
                    </div>
                    
                    <div className="todo__card-progress" style={{width:'100%'}}>
                        <span className={`todo__card-progress_bar ${
                            post?.status === "Completed"? "Completed"
                            : post?.status === 'InProgress' ? 'InProgress'
                            : post?.status === 'Waiting' ? 'Waiting' : ''
                        }`} 
                        style={{width: `${post?.progress}%`}}
                        ></span>
                    </div>
            </div>
            {
                post?.team?.length > 0 && (
                    <div className="todo__info-item">
                        <h4 className="todo__info-title">
                            <FaUsers size={20}/>
                            Team
                        </h4>
                        <div className="todo__info-team">
                            {
                                post?.team?.map((item, i)=>(
                                    <div className="todo__info-team_box" key={i} 
                                    onClick={()=>handleClick(i)}>
                                        <img src={profile} alt="" className="todo__info-team-img" />
                                        {
                                            openTeam === i && (
                                                <div className="todo__info-team_profile">
                                                    <img src={item.pic} alt="" className="todo__info-team-img" />
                                                    <div className="todo__info-team_details">
                                                        <h4 className="todo__info-team_name">{item.name}</h4>
                                                        <span className="todo__info-team_role">{item.role}</span>
                                                    </div>
                                                </div>
                                            )
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                )
            }
            {
                post?.attachment && (
                    <div className="todo__info-item">
                        <h4 className="todo__info-title">
                            <GrAttachment />
                            Attachment
                        </h4>
                        <div className="todo__info-attachment">
                            <img src={`https://backend.aspomportal.com/upload/${post?.attachment}`} alt=""
                            className="todo__info-attachment_img" />
                            <a href={`https://backend.aspomportal.com/upload/${post?.attachment}`} 
                            className="todo__attachment" download>Download</a>
                        </div>
                    </div>
                )
            }
        </div>
    </div>
  )
}

export default TodoInfo